import theme from '@styles/theme';
export default {
  container: (bg: string) => ({
    padding: '64px 16px 64px 16px',
    backgroundColor: bg || theme.rawColors.beige500,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(2,  154px)',
    rowGap: '48px',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  sliderContainer: (bg: string) => ({
    pt: ['80px', '80px', '80px', '80px', '116px'],
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    backgroundColor: bg || theme.rawColors.beige500,
    '.swiper .swiper-slide': {
      backgroundColor: bg || theme.rawColors.beige500
    }
  }),
  productBox: (isBig: boolean) => ({
    width: isBig ? ['154px', '154px', '154px', '23.64583vw'] : '154px',
    height: '100%',
    display: 'flex'
  })
};